<template>
  <div class="mx-auto mt-20 md:w-2/5 w-full p-8">
    <!-- Tab switcher -->
    <div class="flex gap-0 mb-8 border-b border-[#e6e8ea]">
      <button
        type="button"
        class="pb-3 px-1 mr-6 font-[Poppins] font-bold text-sm transition-colors border-b-2 -mb-px"
        :class="
          activeTab === 'login'
            ? 'border-teal-500 text-teal-600'
            : 'border-transparent text-[#6c7a77] hover:text-[#191c1e]'
        "
        @click="activeTab = 'login'"
      >
        Logga in
      </button>
      <button
        type="button"
        class="pb-3 px-1 font-[Poppins] font-bold text-sm transition-colors border-b-2 -mb-px"
        :class="
          activeTab === 'register'
            ? 'border-teal-500 text-teal-600'
            : 'border-transparent text-[#6c7a77] hover:text-[#191c1e]'
        "
        @click="activeTab = 'register'"
      >
        Skapa konto
      </button>
    </div>

    <!-- Login form -->
    <div v-if="activeTab === 'login'">
      <div v-if="alert" class="mb-4 p-3 bg-red-100 text-red-700 rounded">
        {{ alert }}
      </div>

      <form :action="sessionPath" method="post">
        <input type="hidden" name="authenticity_token" :value="csrfToken" />
        <input
          v-if="returnTo"
          type="hidden"
          name="return_to"
          :value="returnTo"
        />
        <input
          v-if="likeRecipeId"
          type="hidden"
          name="like_recipe_id"
          :value="likeRecipeId"
        />

        <div class="my-5">
          <Label>E-post</Label>
          <Input
            type="email"
            name="email_address"
            required
            autofocus
            autocomplete="username"
            placeholder="Ange din e-postadress"
            class="mt-2"
          />
        </div>

        <div class="my-5">
          <Label>Lösenord</Label>
          <Input
            type="password"
            name="password"
            required
            autocomplete="current-password"
            placeholder="Ange ditt lösenord"
            maxlength="72"
            class="mt-2"
          />
        </div>

        <div class="flex items-center gap-4">
          <Button type="submit">Logga in</Button>
          <Link
            :href="newPasswordPath"
            class="text-sm text-muted-foreground underline hover:no-underline"
            >Glömt lösenord?</Link
          >
        </div>
      </form>
    </div>

    <!-- Register form -->
    <div v-else>
      <FormErrors :errors="errors" subject="user" />

      <form :action="usersPath" method="post">
        <input type="hidden" name="authenticity_token" :value="csrfToken" />
        <input
          v-if="returnTo"
          type="hidden"
          name="return_to"
          :value="returnTo"
        />
        <input
          v-if="likeRecipeId"
          type="hidden"
          name="like_recipe_id"
          :value="likeRecipeId"
        />

        <div class="my-5">
          <Label>E-post</Label>
          <Input
            type="email"
            name="user[email_address]"
            required
            autofocus
            autocomplete="username"
            placeholder="E-postadress"
            class="mt-2"
          />
        </div>

        <div class="my-5">
          <Label>Lösenord</Label>
          <Input
            type="password"
            name="user[password]"
            required
            autocomplete="new-password"
            placeholder="Lösenord"
            maxlength="72"
            class="mt-2"
          />
        </div>

        <div class="my-5">
          <Label>Bekräfta lösenord</Label>
          <Input
            type="password"
            name="user[password_confirmation]"
            required
            autocomplete="new-password"
            placeholder="Bekräfta lösenord"
            maxlength="72"
            class="mt-2"
          />
        </div>

        <Button type="submit">Skapa konto</Button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Link } from "@inertiajs/vue3";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import FormErrors from "@/components/form/FormErrors.vue";
import AppLayout from "@/layouts/AppLayout.vue";

const props = defineProps({
  activeTab: { type: String, default: "login" },
  csrfToken: { type: String, required: true },
  sessionPath: { type: String, required: true },
  usersPath: { type: String, required: true },
  newPasswordPath: { type: String, required: true },
  alert: { type: String, default: null },
  errors: { type: Array, default: () => [] },
  returnTo: { type: String, default: null },
  likeRecipeId: { type: [String, Number], default: null },
});

const activeTab = ref(props.activeTab);

defineOptions({
  layout: AppLayout,
});
</script>
